import { REQUIREMENT_DATA } from '../requirementData'
import { STATUS_COLORS, STATUS_BACKGROUND_COLORS } from '../theme'
import { STATUS, STATUS_CATEGORIES } from './constants/statuses'
import { LEVEL, REQUIREMENT } from './constants/levels'
import { getLevelKeyFromCode } from './progressUtils'

export const MEMBER_STATUS_LABEL = {
  [LEVEL.LEVEL_3]: 'Level 3 Associate',
  [LEVEL.LEVEL_2]: 'Level 2 Associate',
  [LEVEL.LEVEL_1]: 'Level 1 Associate',
  QUALIFIER_ELIGIBLE: 'Qualifier Eligible',
  PRE_QUALIFIER: 'Pre-Qualifier',
}

export const getStatusColor = (status) => {
  return STATUS_COLORS[status] || STATUS_COLORS.default
}

export const getStatusBackgroundColor = (status) => {
  return STATUS_BACKGROUND_COLORS[status] || STATUS_BACKGROUND_COLORS.default
}

export const getRequirementDisplayData = (levelKey, requirement) => {
  const levelData = REQUIREMENT_DATA[levelKey]
  if (!levelData) return null

  const reqData = levelData.requirements[requirement.id]
  if (!reqData) return null

  const statusData = reqData.statuses[requirement.status]
  if (!statusData) return null

  const baseStatusData = {
    name: reqData.name,
    color: getStatusColor(requirement.status),
    backgroundColor: getStatusBackgroundColor(requirement.status),
    ...statusData,
  }

  const { id, status, seminarRegistration } = requirement
  const isSeminarRequirement = id === REQUIREMENT.SEMINAR || id === REQUIREMENT.VIRTUAL_SEMINAR

  // Format seminar message with actual date if registered
  if (
    isSeminarRequirement &&
    status === STATUS.REGISTERED &&
    !!seminarRegistration?.eventStartDate
  ) {
    const { eventStartDate } = seminarRegistration

    // Date is set based on location already/should not factor in timezone
    const [year, month, day] = eventStartDate.split('-').map(Number)
    const date = new Date(year, month - 1, day)

    const formattedDate = date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })

    const dateText = !!eventStartDate ? `on ${formattedDate}` : ''
    const message = `Prepare for your seminar ${dateText} by reviewing the seminar manuals.`

    return {
      ...baseStatusData,
      message,
    }
  }

  return baseStatusData
}

export const getEnrollmentDate = (programHistory = []) => {
  if (!programHistory || programHistory.length === 0) return null

  const level1Program = programHistory.find(
    (program) => program.levelCode && program.levelCode.endsWith('1'),
  )

  if (!level1Program?.startDate) return null

  // Parse the date string: "YYYY-MM-DD" -> "M/D/YYYY"
  const [year, month, day] = level1Program.startDate.split('-')
  return `${parseInt(month)}/${parseInt(day)}/${year}`
}

export const isCompleteStatus = (status) => {
  return STATUS_CATEGORIES.COMPLETE.includes(status)
}

export const isInProgressStatus = (status) => {
  return STATUS_CATEGORIES.IN_PROGRESS.includes(status)
}

export const isLockedStatus = (status) => {
  return STATUS_CATEGORIES.LOCKED.includes(status)
}

export const isReadyStatus = (status) => {
  return STATUS_CATEGORIES.READY.includes(status)
}

export const getMemberStatusLabel = (levelState) => {
  const currentLevel = getLevelKeyFromCode(levelState?.currentLevelCode)

  // Levels 1-3: have direct label mappings
  if (MEMBER_STATUS_LABEL[currentLevel]) {
    return MEMBER_STATUS_LABEL[currentLevel]
  }

  // Qualifying level: determine PQ/QE status based on course manuals completion
  const qualifyingLevel = levelState?.qualifying
  const courseManualsRequirement = qualifyingLevel?.requirements?.find(
    req => req.id === REQUIREMENT.COURSE_MANUALS
  )
  const isCourseManualsComplete = courseManualsRequirement && isCompleteStatus(courseManualsRequirement.status)

  return isCourseManualsComplete
    ? MEMBER_STATUS_LABEL.QUALIFIER_ELIGIBLE
    : MEMBER_STATUS_LABEL.PRE_QUALIFIER
}
